// extracted by mini-css-extract-plugin
export default {"callUsIcon":"CallUs_callUsIcon__AZZ8l"};